import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { AppBrowserSettings } from "./AppBrowserSettings";
import { AppShellCheck, IShellMemory } from "./AppShellCheck";

// AppShellGuard - the browser half of `AppShellCheck` (the rules have no habitat, so the Bridge suite can import
// them; this file touches `document`, `sessionStorage` and `location`).

/** This tab's memory of the last shell reload. ⚠ `sessionStorage` THROWS in some private modes - every access wrapped. */
export class AppShellMemory implements IShellMemory {
    public static readonly Key: string = "wac.shellReload";

    /** Unusable storage is the shared class's "nothing stored": reads as "nothing remembered". */
    public Read = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return nz(AppBrowserSettings.Session().ReadText(AppShellMemory.Key).Value);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppShellMemory.Read");
            return "";
        }
    };

    /** Unusable storage only loses the loop guard's memory (the shared class answers a plain outcome, keeps nothing in page
     *  memory); the reload still happens once per page load at most, and `AppFrameHeal` styles the page either way. */
    public Write = (Value: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            AppBrowserSettings.Session().WriteText(AppShellMemory.Key, Value);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppShellMemory.Write");
        }
    };
}

export class AppShellGuard {
    /** Reloads the page when this bundle runs inside another build's shell; answers true when it did. */
    public static Run = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            const Meta: Element | null = document.querySelector("meta[http-equiv=\"Content-Security-Policy\"]");
            let Found: string = "";
            if (Meta !== null) { Found = nz(Meta.getAttribute("content")); }
            if (AppShellCheck.ShouldReload(Found, new AppShellMemory(), Date.now()) === false) { return false; }
            window.location.reload();
            return true;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppShellGuard.Run");
            return false;
        }
    };
}
